module.exports = __webpack_public_path__ + "img/软件产品登记测试报告.cb4e94fd.svg";